import React, {Component} from 'react';
import {Toast,Picker,List} from 'antd-mobile';
import {goodsEndCity, startCity,goodsSite} from '../../../service/homeService';
import CityModal from "../../../components/CityModal";
import {connect} from "react-redux";
import './style.less';
import BMap from "BMap";
const seasons = {
    data: "这里是线路id",
    data1: [{
        label: '2013-2-1',
        value: '2013-2-1',
        children: [
            {value: "10:00", label: "10:00",},
            {value: "11:00", label: "11:00"},
        ]
    },
        {
            label: '2013-2-2',
            value: '2013-2-2',
            children: [
                {value: "10:00", label: "10:00"},
                {value: "16:00", label: "16:00"},
            ]
        },]
};
@connect(
    state => ({userInfo: state.userInfo})
)
export default class BringGoods extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cityModal:false,
            cityType:"bringGood",
            modalType:"start",
            cityData:{},
            startAddress:'',
            address:'',
            appointmentTime:"",
            siteDate:"",
            endSite:"",
            province:this.props.province,
            currentCity:"",
            seasons:[],
            lineId:"",
        };
    }
    componentDidMount() {
        // let geolocation = new BMap.Geolocation();
        // const self = this;
        // geolocation.getCurrentPosition(function (r) {
        //     self.setState({province:r.address.province});
        // });
    }


    //获取开始城市列表
    getStartCityList = (province,letter) => {
        this.setState({province: province,cityModal: true,cityType:"bringGood",modalType:"start"});
        const params = {
            source:1,
            token:this.props.userInfo.token,
            data:{
                displayName:'',
                provinceName:province === "全部" ? "" : province,
                label:letter,
            },
        };
        startCity(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.hide();
                this.setState({cityData: res.data.data});
            }else{
                Toast.info(res.data.msg,3)
            }
        })
    };
    goAddress(v){
        if(this.state.siteDate == ''){
            Toast.info('请选择寄货城市',2);
            return
        }
        const params = {
            source: 1,
            token:this.props.userInfo.token,
            data:{
                displayName:this.state.startAddress,
                label:v,
            }
        };
        Toast.loading("");
        goodsEndCity(params).then((res) => {
            if (res.data.code === '0000') {
                this.setState({cityData: res.data.data,cityModal: true,modalType:'end'});
                Toast.hide();
            }else{
                Toast.info(res.data.msg,3)
            }
        });
    }
    changeCity(n){
        if(this.state.modalType == "start"){
            this.setState({cityModal: false,cityData:[],startAddress:n.name,siteDate:n,address:"",endSite:"",appointmentTime:""});
        }else{
            this.setState({cityModal: false,cityData:[],address:n.name,endSite:n});
            let params = {
                source: 1,
                token: this.props.userInfo.token,
                data: {
                    startCity: this.state.startAddress,
                    endCity:n.name,
                }
            };
            goodsSite(params).then((res)=>{
                if (res.data.code === '0000') {
                    this.setState({seasons:res.data.data,lineId:res.data.data.lineId});
                }else{
                    Toast.info(res.data.msg,3)
                }
            })
        }
    }

    cityClose = () => {
        this.setState({
            cityModal: false,
            cityData: [],
        });
    };
    timeChange(date){
        if(this.state.startAddress === ""){
            Toast.info("请选择寄货城市");
            return
        }
        if(this.state.address === ""){
            Toast.info("请选择货物目的地城市");
            return
        }
        this.setState({ appointmentTime:date});
    }
    //寄货
    takeCar(){
        if(this.state.startAddress == ''){
            Toast.info('请选择寄货城市',2);
            return
        }
        if(this.state.address == ''){
            Toast.info('请选择货物目的地城市');
            return;
        }
        if(this.state.appointmentTime == ''){
            Toast.info('请选择寄货时间');
            return;
        }
        let params = {
            lineId:this.state.lineId,
            shiftId:this.state.appointmentTime[1],
        };
        this.props.history.push('/goodsInfo',params);
    }
    render() {
        return (
            <div className='bringGoods'>
                <div className="typeBox">
                    <div className="area">
                        <div className="start">
                            <i className="icon iconfont iconchufa"/>
                            <div className="startSite"  onClick={() => this.getStartCityList(this.state.province)}>
                                {this.state.startAddress === "" ? <span>请选择寄货城市</span> : this.state.startAddress}
                            </div>
                        </div>
                        <div className="end">
                            <i className="icon iconfont icondaoda"/>
                            <div className="endSite" onClick={() =>{this.goAddress()}}>
                                {this.state.address == '' ? <span>请选择货物目的地城市</span> : this.state.address}
                            </div>
                        </div>
                        <div className="dateMenu">
                            <Picker
                                data={this.state.seasons.shiftList}
                                cols={2}
                                title="请选择寄货时间"
                                extra='请选择寄货时间'
                                value={this.state.appointmentTime}
                                onOk={v => this.timeChange(v)}
                            >
                                <List.Item ><i className="icon iconfont iconshijian1"/></List.Item>
                            </Picker>
                        </div>

                    </div>
                    <div className="reserveBtn" onClick={()=>this.takeCar()}>预约带货</div>
                </div>
                <div className="contactUs">客服热线<a href="tel:4001389889">4001389889</a></div>
                <CityModal
                    modal={this.state.cityModal}
                    modalType={this.state.modalType}//出发还是到达的modal
                    onClose={this.cityClose.bind(this)}
                    data={this.state.cityData}//城市列表数据
                    changeCity={this.changeCity.bind(this)}//切换城市事件
                    cityType = {this.state.cityType}//乘车类型
                    hotData=""//热门地州
                    nearbySite=""
                    province={this.state.province}
                    getStartCityList={this.getStartCityList.bind(this)}
                    getEndCityList={this.goAddress.bind(this)}
                    {...this.props}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/BringGoods/index.js